exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button[data-v-c99ece7c]:hover {\n  opacity: 0.7;\n}", ""]);

// exports
